import React, { useState, useEffect } from 'react';
import { AiFillInfoCircle } from 'react-icons/ai';
import { useParams, useNavigate } from 'react-router-dom';
import axios from '../../Api/axios';
import {
  ResetButton,
  ResetContainer,
  ResetForm,
  ResetHeader,
  ResetInput,
  ResetWrapper,
  ErrorText,
  FeedbackText,
  InputHolder,
  SuccessMessage,
} from './resetPasswordElements';

const PWD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%_.-]).{8,24}$/;

const ResetSection = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [feedback, setFeedback] = useState('');
  const [success, setSuccess] = useState(false);

  const [validPassword, setValidPassword] = useState(false);
  const [validMatch, setValidMatch] = useState(false);

  const { id, token } = useParams();
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    // Security
    if (!password || !confirmPassword) {
      setFeedback('Please enter a password');
      return;
    }

    const v1 = PWD_REGEX.test(password);

    if (!v1) {
      setFeedback('Invalid Entry');
      return;
    }
    // Security END

    try {
      axios.post(
        `/reset/${id}/${token}`,
        JSON.stringify({
          password,
        }),
        {
          headers: { 'Content-Type': 'application/json' },
          withCredentials: true,
        },
      ).then((res) => {
        if (res.data.status === 'error') setFeedback(res.data.message);
        else {
          setFeedback(res.data.message);
          setSuccess(true);
        }
      }).catch((error) => {
        if (error.response.status === 409
          || error.response.status === 400) setFeedback(error.response.data.message);
        else if (error.response.status === 401) setFeedback(error.response.data.message);
        else if (error) setFeedback('No server response');
        else {
          setFeedback('Something went wrong');
          console.log('Error', error.message);
        }
      });
    } catch (err) {
      if (!err?.response) setFeedback('No server response');
      else setFeedback('Registration failed');
    }
  };

  // Password verification
  useEffect(() => {
    const result = PWD_REGEX.test(password);
    setValidPassword(result);
    const match = password === confirmPassword;
    setValidMatch(match);
  }, [password, confirmPassword]);

  // Error handling
  useEffect(() => {
    setFeedback('');
  }, [password, confirmPassword]);

  useEffect(() => {
    if (!id || !token) navigate('/unauthorized');
  }, []);

  return (
    <ResetContainer>
      <ResetWrapper>
        {!success ? (
          <>
            <ResetHeader>Password Reset</ResetHeader>
            <ResetForm onSubmit={handleSubmit}>
              <InputHolder>
                <ResetInput
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter your new password"
                  autoComplete="off"
                  aria-invalid={validPassword ? 'false' : 'true'}
                  aria-describedby="uidnote1"
                  type="password"
                  name="password"
                />
                {password && !validPassword && (
                  <ErrorText id="uidnote1">
                    <AiFillInfoCircle />
                    &nbsp;
                    4 to 24 characters.
                    <br />
                    Must begin with a letter.
                    <br />
                    Must contain an uppercase letter.
                    <br />
                    Must contain Symbols such !@#$%^&*.
                  </ErrorText>
                )}
              </InputHolder>
              <InputHolder>
                <ResetInput
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="Confirm your new password"
                  autoComplete="off"
                  aria-invalid={validPassword ? 'false' : 'true'}
                  aria-describedby="uidnote2"
                  type="password"
                  name="confirmPassword"
                />
                {confirmPassword && !validMatch && (
                  <ErrorText id="uidnote2">
                    <AiFillInfoCircle />
                    &nbsp;
                    Passwords are not matching.
                  </ErrorText>
                )}
              </InputHolder>
              <ResetButton disabled={!validMatch ? true : false || !validPassword} type="submit">Reset</ResetButton>
              <FeedbackText>{feedback}</FeedbackText>
            </ResetForm>
          </>
        ) : (
          <>
            <SuccessMessage>{feedback}</SuccessMessage>
            <ResetButton onClick={() => navigate('/login')}>Back to login page</ResetButton>
          </>
        )}
      </ResetWrapper>
    </ResetContainer>
  );
};

export default ResetSection;
